// extracted by mini-css-extract-plugin
export default {"comments":"CommentsPage_comments__cq5hY","content":"CommentsPage_content__Fli9I"};